module.exports = __webpack_public_path__ + "img/banner.png";


//////////////////
// WEBPACK FOOTER
// ./resources/views/partials/index/header/img/banner.png
// module id = 53
// module chunks = 0